export const EmptyState = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="280"
    height="195"
    viewBox="0 0 280 195"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_65_2990)">
      <path
        d="M228.918 10.4603L230.958 3.72536C230.958 3.72536 232.388 0.863297 235.828 2.69334C238.748 4.24674 237.388 7.1514 237.388 7.1514L233.008 13.2586"
        fill="white"
      />
      <path
        d="M228.918 10.4603L230.958 3.72536C230.958 3.72536 232.388 0.863297 235.828 2.69334C238.748 4.24674 237.388 7.1514 237.388 7.1514L233.008 13.2586"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M101.487 163.737L94.1771 171.823L88.0371 163.237L78.7071 173.664L73.6671 165.003L63.3071 174.856L60.1271 165.886L48.9371 176.473L45.0671 167.067L33.8771 177.952L30.2871 168.983L19.0971 179.718L14.7971 170.217L3.80712 180.654C-12.9029 120.029 66.1271 113.464 81.2071 111.017C96.2871 108.57 99.7371 98.9092 99.7371 98.9092"
        fill="black"
      />
      <path
        d="M101.487 163.737L94.1771 171.823L88.0371 163.237L78.7071 173.664L73.6671 165.003L63.3071 174.856L60.1271 165.886L48.9371 176.473L45.0671 167.067L33.8771 177.952L30.2871 168.983L19.0971 179.718L14.7971 170.217L3.80712 180.654C-12.9029 120.029 66.1271 113.464 81.2071 111.017C96.2871 108.57 99.7371 98.9092 99.7371 98.9092"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M184.735 116.039L184.055 126.562L179.015 117.805L177.675 127.434L172.555 118.933"
        fill="white"
      />
      <path
        d="M184.735 116.039L184.055 126.562L179.015 117.805L177.675 127.434L172.555 118.933"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M201.748 52.7432C212.638 77.3529 211.728 113.549 173.418 118.763L201.748 52.7432Z"
        fill="white"
      />
      <path
        d="M201.748 52.7432C212.638 77.3529 211.728 113.549 173.418 118.763"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M169.278 124.402C172.948 139.926 177.038 167.153 156.118 183.549C156.118 183.549 179.558 182.261 179.558 193.316H139.768C139.768 193.316 139.898 186.251 144.708 183.666C144.708 183.666 130.798 176.484 130.168 154.715L130.468 141.394"
        fill="white"
      />
      <path
        d="M169.278 124.402C172.948 139.926 177.038 167.153 156.118 183.549C156.118 183.549 179.558 182.261 179.558 193.316H139.768C139.768 193.316 139.898 186.251 144.708 183.666C144.708 183.666 130.798 176.484 130.168 154.715L130.468 141.394"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M89.0353 182.686C75.1053 138.51 106.825 68.8089 143.315 34.4425C185.995 -5.7651 243.385 -13.4257 278.755 68.5323L270.145 71.5115C270.365 71.6285 238.435 46.4974 222.705 46.4974C217.675 46.4974 214.215 50.2532 210.675 54.6687C192.345 77.5336 173.815 147.99 131.485 147.905C131.485 147.905 132.205 179.43 99.6853 183.92C99.6853 183.92 124.525 182.282 124.525 193.315H83.9453C84.2153 192.709 83.5353 185.016 89.0453 182.686H89.0353Z"
        fill="white"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M130.318 157.438C130.318 157.438 133.678 142.638 127.758 131.765"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M216.647 40.9229L202.547 62.1066"
        stroke="black"
        strokeWidth="3"
        strokeLinejoin="round"
      />
      <path
        d="M206.769 13.823L204.079 6.74764C204.079 6.74764 201.969 2.55554 206.769 1.45965C211.259 0.427586 211.509 4.64092 211.509 4.64092L211.529 12.8974"
        fill="white"
      />
      <path
        d="M206.769 13.823L204.079 6.74764C204.079 6.74764 201.969 2.55554 206.769 1.45965C211.259 0.427586 211.509 4.64092 211.509 4.64092L211.529 12.8974"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M200.648 56.6694L209.918 53.4668L205.068 60.2018L211.528 59.0633L206.258 64.6492L211.688 64.6917L204.468 70.6181"
        fill="white"
      />
      <path
        d="M200.648 56.6694L209.918 53.4668L205.068 60.2018L211.528 59.0633L206.258 64.6492L211.688 64.6917L204.468 70.6181"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M152.234 77.7571C159.214 84.7474 169.364 89.9397 178.244 89.9397C193.344 89.9397 208.224 73.6821 204.564 59.1163C204.074 57.1692 202.094 56.1158 200.334 56.8393L182.354 64.1808C181.694 64.4468 180.974 64.4894 180.304 64.2659C177.674 63.4147 170.604 60.5952 163.084 53.1367"
        fill="white"
      />
      <path
        d="M152.234 77.7571C159.214 84.7474 169.364 89.9397 178.244 89.9397C193.344 89.9397 208.224 73.6821 204.564 59.1163C204.074 57.1692 202.094 56.1158 200.334 56.8393L182.354 64.1808C181.694 64.4468 180.974 64.4894 180.304 64.2659C177.674 63.4147 170.604 60.5952 163.084 53.1367"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M275.767 61.9785L263.938 66.8728L270.147 71.5118L278.568 68.3517L275.767 61.9785Z"
        fill="#7A68FA"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M225.147 40.4968C231.289 40.4968 236.267 35.1997 236.267 28.6654C236.267 22.1311 231.289 16.834 225.147 16.834C219.006 16.834 214.027 22.1311 214.027 28.6654C214.027 35.1997 219.006 40.4968 225.147 40.4968Z"
        fill="white"
        stroke="black"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M225.147 32.9536C227.373 32.9536 229.177 31.0338 229.177 28.6657C229.177 26.2976 227.373 24.3779 225.147 24.3779C222.921 24.3779 221.117 26.2976 221.117 28.6657C221.117 31.0338 222.921 32.9536 225.147 32.9536Z"
        fill="black"
      />
      <path
        d="M244.89 26.0693L240.93 29.623L245.78 32.6128"
        stroke="black"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M220.18 55.8399C220.18 55.8399 223.26 53.4567 227.08 54.9675"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M223.938 59.5836C223.938 59.5836 227.918 58.2004 230.658 60.4986"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_65_2990">
        <rect
          width="279"
          height="195"
          fill="white"
          transform="translate(0.5)"
        />
      </clipPath>
    </defs>
  </svg>
);
